import { addDays, compareCivilDates, toCivilDate } from './civil-date.js';
export const graceDaysFor = (kind, autoGraceDays) => {
    if (!Number.isInteger(autoGraceDays) || autoGraceDays < 0) {
        throw new RangeError(`autoGraceDays must be a non-negative integer, got ${autoGraceDays}`);
    }
    return kind === 'auto_debit' ? autoGraceDays : 0;
};
/**
 * Three states, exactly as the design document defines them: `upcoming` while the due date is
 * still ahead, `overdue` once the grace window has closed, `due_today` in between. The middle
 * case covers both the due date itself and the grace days that follow it — an auto-debit
 * waiting for confirmation is not a debt yet, but it is not "later" either.
 */
export const occurrenceTimeState = (input) => {
    if (!Number.isInteger(input.graceDays) || input.graceDays < 0) {
        throw new RangeError(`graceDays must be a non-negative integer, got ${input.graceDays}`);
    }
    const isDueLater = compareCivilDates(input.dueDate, input.today) > 0;
    if (isDueLater) {
        return 'upcoming';
    }
    const graceEndsOn = addDays(input.dueDate, input.graceDays);
    const isGraceWindowClosed = compareCivilDates(graceEndsOn, input.today) < 0;
    return isGraceWindowClosed ? 'overdue' : 'due_today';
};
export const occurrenceTimeStateAt = (input) => occurrenceTimeState({
    dueDate: input.dueDate,
    today: toCivilDate(input.now, input.timeZone),
    graceDays: input.graceDays,
});
/**
 * A decided occurrence keeps its decision; only a `planned` one gets its answer from the calendar.
 */
export const occurrenceDisplayStatus = (input) => {
    if (input.status !== 'planned') {
        return input.status;
    }
    return occurrenceTimeState({
        dueDate: input.dueDate,
        today: input.today,
        graceDays: input.graceDays,
    });
};
//# sourceMappingURL=occurrence-state.js.map